import { render, staticRenderFns } from "./mailPage.vue?vue&type=template&id=2ec58f08&"
import script from "./mailPage.vue?vue&type=script&lang=js&"
export * from "./mailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports